module.exports = __webpack_public_path__ + "static/media/icon_sent.4dda8b67.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_sent.svg
// module id = 321
// module chunks = 0